import { IChatActionTypes } from "models/IChatModelState";

/**
 * CRA inlines `REACT_APP_*` at build time. Default reverse-proxy is off unless the env is
 * true | 1 | yes. Set `REACT_APP_DEFAULT_REVERSE_PROXY_ON` in the job that runs
 * `yarn run build` / `npm run build` (e.g. GitLab CI). Kubernetes pod env on the nginx image
 * does not change this value without a rebuild.
 */
function defaultReverseProxyOnFromEnv(): boolean {
  const v = process.env.REACT_APP_DEFAULT_REVERSE_PROXY_ON;
  if (v == null || String(v).trim() === "") return false;
  return ["true", "1", "yes"].includes(String(v).trim().toLowerCase());
}

const initialState: any = {
  thread_list: {},
  chat_rooms_list: {},
  chat_room_params: {
    isAcxioChat: false,
    roomId: "",
    threadId: "",
    roomName: "",
    isNewChat: false,
    is_closed: false,
    threadName: "",
    adminMembers: [],
  },

  //   taskUpdates:{
  //     "message": "😕 Oops! Looks like the Job Assessment didn't go as planned for **Telugu Audio Recording - Officer**.\n",
  //     "status": "completed",
  //     "type": "assessment"
  // }

  taskUpdates: {
    status: "",
    type: "",
    message: "",
  },
  isProxyOn: defaultReverseProxyOnFromEnv(),
  toggleUserAvatarChange: false,
};

const reducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case IChatActionTypes.TOGGLE_REVERSE_PROXY:
      return {
        ...state,
        isProxyOn: !state.isProxyOn,
      };
      
    case IChatActionTypes.TOGGLE_USER_AVATAR_CHANGE:
      return {
        ...state,
        toggleUserAvatarChange: !state.toggleUserAvatarChange,
      };

    case IChatActionTypes.UPDATE_TASK_UPDATES:
      return {
        ...state,
        taskUpdates: payload,
      };

    case IChatActionTypes.FETCH_THREADSLIST_REQUEST:
      return {
        ...state,
        thread_list: {},
      };

    case IChatActionTypes.FETCH_THREADSLIST_SUCCESS:
      return {
        ...state,
        thread_list: { ...payload },
      };

    case IChatActionTypes.FETCH_CHATROOMS_SUCCESS:
      return {
        ...state,
        chat_rooms_list: { ...payload },
      };

    case IChatActionTypes.UPDATE_CHANGEEVENT_FOR_CHAT:
      return {
        ...state,
        chat_room_params: { ...state.chat_room_params, ...payload },
      };

    default:
      return state;
  }
};

export default reducer;
